module.exports = __webpack_public_path__ + "testerstatic/media/illus-clock.5d9467cc.svg";